import moment from "moment";
import apiClient from "../../../apiClient";
import { fileDownload } from "../../../utils";
import { Button } from "reactstrap";
import Layout from "../../../components/custom/Layout";

export default function UaSlaEmployee() {

    const downloadData = async () => {
        try {
            const res = await apiClient.get(`/dev/employee-sla`);
            fileDownload(res.data, `Employee SLA ${moment().format('YYYY-MM-DD-hh-mm')}.csv`);
        } catch (err) {
            alert(err);
        }
    }

    return (
        <Layout>
            <div>
                <Button onClick={downloadData}>Download Data</Button>
            </div>
        </Layout>
    );
}